import { Navigate, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../Components/Buttons/primary-button";
import { useConsumerDealsData } from "../Deals";

import renderContactSupportModal from "../../Organisms/Modals/MyUtilities/contact-support-modal";

import { useModalContext } from "../../Contexts/ModalContext";

import { useMyUtilitiesOrderDetail } from "../../CustomHooks/Queries";

import { formatDate } from "../../Utils/helpers";
import { longMonthDateFormat } from "../../Utils/constants";

import { ChevronLeft } from "../../Assets/Icons";

import "./manage.scss";

export default function ManageUtilities() {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const { isLoadingConsumerDealsData, myUtilitiesOffer } = useConsumerDealsData();

  const { data: orderResponse, isLoading: isLoadingUtilitiesOrderDetail } = useMyUtilitiesOrderDetail(
    myUtilitiesOffer?.token,
    {
      enabled: !!myUtilitiesOffer?.token,
    }
  );

  const orderData = orderResponse?.data?.data;

  if (!myUtilitiesOffer?.token) {
    return <Navigate to="/deals" />;
  }

  const isLoading = isLoadingUtilitiesOrderDetail || isLoadingConsumerDealsData;

  return (
    <div className="my-utilities-manage">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header">
              <button className="go-back-button" onClick={() => navigate(-1)} aria-label="Go back">
                <ChevronLeft />
              </button>
              <h3 className="section-title">My Utilities</h3>
              <div className="dummy" />
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : (
              <div className="content">
                {!orderData ? (
                  <div className="no-records">Order details not found</div>
                ) : (
                  <>
                    <div className="top-container">
                      <div className="info-title">Order Details</div>
                      <div className="detail-row">
                        <span className="label">Order ID</span>
                        <span className="value">{orderData?.order_id || "N/A"}</span>
                      </div>
                      <div className="detail-row align-items-center">
                        <span className="label">Status</span>
                        <div className="value">
                          <div className="status-badge">{orderData?.status || "Pending"}</div>
                        </div>
                      </div>
                      <div className="detail-row">
                        <span className="label">Created At</span>
                        <span className={`value${!orderData?.created_date ? " not-available" : ""}`}>
                          {orderData?.created_date
                            ? formatDate(orderData?.created_date, longMonthDateFormat)
                            : "Not available"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Close Date</span>
                        <span className={`value${!orderData?.closed_at ? " not-available" : ""}`}>
                          {orderData?.closed_at
                            ? formatDate(orderData?.closed_at, longMonthDateFormat)
                            : "Not available"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Move-in Date</span>
                        <span className={`value${!orderData?.move_in_date ? " not-available" : ""}`}>
                          {orderData?.move_in_date
                            ? formatDate(orderData?.move_in_date, longMonthDateFormat)
                            : "Not available"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Address</span>
                        <span className={`value${!orderData?.address ? " not-available" : ""}`}>
                          {orderData?.address || "Not available"}
                        </span>
                      </div>
                    </div>
                    <div className="bottom-container">
                      <PrimaryButton onClick={() => renderContactSupportModal(modalContext)}>
                        Need help? Contact Support
                      </PrimaryButton>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
